import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "flex-row-box digitalman-customized-page"
};
const _hoisted_2 = {
  class: "content flex-column-box"
};
const _hoisted_3 = {
  class: "flex-row-box flex-start"
};
const _hoisted_4 = {
  class: "flex-row-box flex-start"
};
const _hoisted_5 = {
  class: "flex-column-box",
  style: {
    "width": "100%"
  }
};
const _hoisted_6 = {
  class: "flex-row-box",
  style: {
    "justify-content": "flex-start"
  }
};
const _hoisted_7 = {
  style: {
    "width": "30%"
  }
};
const _hoisted_8 = {
  style: {
    "width": "30%",
    "height": "100%",
    "margin-left": "40px"
  }
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "flex-column-box",
  style: {
    "width": "100%"
  }
};
const _hoisted_11 = {
  class: "flex-row-box",
  style: {
    "justify-content": "flex-start"
  }
};
const _hoisted_12 = {
  style: {
    "width": "30%"
  }
};
const _hoisted_13 = {
  style: {
    "width": "30%",
    "height": "100%",
    "margin-left": "40px"
  }
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "flex-column-box",
  style: {
    "width": "100%"
  }
};
const _hoisted_16 = {
  class: "flex-row-box",
  style: {
    "justify-content": "flex-start"
  }
};
const _hoisted_17 = {
  style: {
    "width": "30%"
  }
};
const _hoisted_18 = {
  class: "flex-column-box radius-middle",
  style: {
    "width": "200px",
    "height": "260px",
    "margin-left": "40px",
    "background": "#F2F4F7",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_19 = {
  class: "footer flex-row-box"
};
const _hoisted_20 = {
  class: "active-text-plain",
  style: {
    "text-decoration": "underline"
  }
};
import { ref, onMounted, reactive } from 'vue';
import { useRouter } from "vue-router";
import { customMake } from '@/request/customrize';
import { ElMessageBox, ElMessage } from 'element-plus';
import 'element-plus/es/components/message-box/style/index'
import 'element-plus/es/components/message/style/index'

import { useMainStore } from '@/pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'digitalman',
  setup(__props) {
    const store = useMainStore();
    const router = useRouter();
    const baseApi = process.env.VUE_APP_API_BASE_URL;
    console.log('baseApi:', baseApi);
    const form = reactive({
      anchorName: '',
      makeType: 'IMAGE_GENERAL',
      // 视频格式授权书URL	
      identityCosUrl: '',
      // pdf 格式授权书 URL	
      identityWrittenCosUrl: '',
      // 形象定制素材 url 地址要求	
      materialCosUrl: '',
      isHaveBackground: false,
      sexType: '',
      notes: '',
      textDriver: '',
      voiceDriverCosFile: ''
    });
    const customrizeType = ref([]);
    // 1: 视频授权 2: pdf授权
    const identityType = ref(1);
    const agree = ref(false);
    const onSubmit = () => {
      ElMessageBox.confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        submit();
      });
    };
    const submit = () => {
      customMake(form).then(res => {
        console.warn(88, res);
        const {
          code,
          data,
          msg
        } = res.data;
        if (code == 200) {
          ElMessage({
            type: 'success',
            message: '提交成功!'
          });
          router.push('/work-plateform');
        } else {
          ElMessage({
            type: 'error',
            message: msg
          });
        }
      });
    };
    let typeOptions = ref([]);
    const imageTimbreCustom = [{
      label: '普通形象定制',
      value: 'IMAGE_GENERAL'
    }, {
      label: '专属形象定制',
      value: 'IMAGE'
    }];
    const soundClone = [{
      label: '声音定制',
      value: 'VOICE'
    }];
    if (store.userInfo.imageTimbreCustomStatus) {
      typeOptions.value = [...typeOptions.value, ...imageTimbreCustom];
    }
    if (store.userInfo.soundCloneStatus) {
      typeOptions.value = [...typeOptions.value, ...soundClone];
    }
    const genderOption = [{
      label: '男',
      value: 'MALE'
    }, {
      label: '女',
      value: 'FEMALE'
    }];
    // const credentials = ref();
    // const getCredentials = ()=>{
    //   getUploadCredentials().then(res=>{
    //     const {code, data} = res.data;
    //     if(code==200) credentials.value = data;
    //   })
    // }
    // getCredentials();
    const downloadAuthVoice = () => {
      window.open('/口述版形象授权书.zip');
    };
    const downloadAuthPaper = () => {
      window.open('/书面版形象授权书.zip');
    };
    const downloadAuthFile = () => {
      window.open('/示例音频文件.zip');
    };
    // 授权信息上传成功
    const identityLoading = ref(false);
    const handleIdentitySuccess = response => {
      console.log(identityType.value, 222);
      if (identityType.value == 1) {
        form.identityCosUrl = response.data;
      } else {
        form.identityWrittenCosUrl = response.data;
      }
      identityLoading.value = false;
    };
    // 授权信息before upload
    const handleIdentityBeforeUpload = file => {
      if (file.type.includes('pdf')) identityType.value = 2;else identityType.value = 1;
      identityLoading.value = true;
      return true;
    };
    const handleIdentityChange = (file, fileList) => {
      console.log(77, file);
    };
    // 视频训练素材上传成功
    const videoLoading = ref(false);
    const handleVideoSuccess = response => {
      form.materialCosUrl = response.data;
      videoLoading.value = false;
    };
    // 视频训练素材改变
    const handleVideoChange = () => {};
    const handleVideoBeforeUpload = () => {
      videoLoading.value = true;
      return true;
    };
    // 音频素材
    const audioLoading = ref(false);
    const handleAudioSuccess = response => {
      form.voiceDriverCosFile = response.data;
      audioLoading.value = false;
    };
    // 音频素材
    const handleAudioChange = () => {};
    const handleAudioBeforeUpload = () => {
      audioLoading.value = true;
      return true;
    };
    onMounted(() => {});
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_plus = _resolveComponent("plus");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_svgIcon = _resolveComponent("svgIcon");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
        modelValue: form,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form = $event),
        style: {
          "height": "100px",
          "flex-grow": "2",
          "overflow": "auto",
          "padding": "20px 0 60px 0"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[11] || (_cache[11] = _createElementVNode("h3", {
          style: {
            "margin-top": "18px"
          }
        }, "定制类型", -1)), _createVNode(_component_el_select, {
          modelValue: form.makeType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.makeType = $event),
          placeholder: "定制类型",
          style: {
            "width": "200px",
            "margin-left": "20px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _cache[27] || (_cache[27] = _createElementVNode("div", {
          class: "note-wrap radius-middle"
        }, [_createElementVNode("p", {
          style: {
            "margin-bottom": "10px"
          }
        }, " 提交前请务必逐条核查以下自检项： "), _createElementVNode("p", null, [_createTextVNode("1. 视频画面："), _createElementVNode("span", {
          class: "shallow-text"
        }, "人脸清晰不模糊，人脸区域放大后边缘轮廓清晰，画面稳定无晃动。")]), _createElementVNode("p", null, [_createTextVNode("2. 模特表现："), _createElementVNode("span", {
          class: "shallow-text"
        }, "眼睛正视镜头，无大幅转头、偏头，脸部全程无遮挡。")]), _createElementVNode("p", null, [_createTextVNode("3. 拍摄要点："), _createElementVNode("span", {
          class: "shallow-text"
        }, "视频开头静默闭口1-3秒，整条视频全程无剪辑、跳帧，全长须超过1分钟。")]), _createElementVNode("p", null, [_createTextVNode("4. 环境声音："), _createElementVNode("span", {
          class: "shallow-text"
        }, "无需收音，模特可自然说话，也可自然闭嘴。")]), _createElementVNode("p", null, [_createTextVNode("5. 拍摄背景："), _createElementVNode("span", {
          class: "shallow-text"
        }, "如果需我方抠像，则需提供绿幕视频，绿幕需铺满背景、无其他杂物。")])], -1)), _cache[28] || (_cache[28] = _createElementVNode("h3", null, "基础信息", -1)), _createElementVNode("div", _hoisted_4, [form.makeType != 'VOICE' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "数智人名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.anchorName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.anchorName = $event),
            placeholder: "将按此名命名音色及数智人，如“张三_蓝色西装_站姿”；名称字符2-50个"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "音色名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.anchorName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.anchorName = $event),
            placeholder: "将按此名命名音色及数智人，如“张三”；名称字符2-50个"
          }, null, 8, ["modelValue"])]),
          _: 1
        })), _createVNode(_component_el_form_item, {
          label: "角色性别",
          style: {
            "margin-left": "40px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.sexType,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.sexType = $event),
            placeholder: "请选择",
            style: {
              "width": "200px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(genderOption, item => {
              return _createVNode(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]), form.makeType != 'VOICE' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "定制类型"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
            modelValue: customrizeType.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => customrizeType.value = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox, {
              label: 1
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("定制形象")])),
              _: 1
            }), _createVNode(_component_el_checkbox, {
              label: 2
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("定制音色")])),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "备注"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.notes,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.notes = $event),
            placeholder: "请输入内容字数限制为100个字符",
            maxlength: "100"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _cache[29] || (_cache[29] = _createElementVNode("h3", null, "授权信息", -1)), _createVNode(_component_el_form_item, {
          label: "身份授权",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
            class: "flex-row-box",
            style: {
              "justify-content": "flex-start",
              "align-items": "flex-end"
            }
          }, [_cache[15] || (_cache[15] = _createElementVNode("p", {
            style: {
              "width": "30%"
            }
          }, [_createTextVNode("请至少提交1份口述版或书面版授权证明"), _createElementVNode("br"), _createTextVNode(" 授权证明仅限数智人训练，绝不会作他用，请严格按模版提交")], -1)), _createElementVNode("p", {
            style: {
              "margin-left": "40px",
              "width": "30%"
            }
          }, [_cache[14] || (_cache[14] = _createTextVNode(" 下载授权书 ")), _createElementVNode("a", {
            class: "active-text-plain",
            onClick: downloadAuthVoice
          }, "《口述版-形象授权书》"), _createElementVNode("a", {
            class: "active-text-plain",
            onClick: downloadAuthPaper
          }, "《书面版-形象授权书》")])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_withDirectives((_openBlock(), _createBlock(_component_el_upload, {
            "element-loading-text": "正在上传",
            class: "upload-demo",
            drag: "",
            "auto-upload": true,
            action: `${_unref(baseApi)}/app/virtualManApi/custom/upload/idcard`,
            "on-success": handleIdentitySuccess,
            "on-change": handleIdentityChange,
            "before-upload": handleIdentityBeforeUpload,
            limit: 1,
            multiple: false,
            ref: "identityUpload"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-icon--upload",
              size: "20px"
            }, {
              default: _withCtx(() => [_createVNode(_component_plus)]),
              _: 1
            }), _cache[16] || (_cache[16] = _createElementVNode("div", {
              class: "el-upload__text",
              style: {
                "padding": "20px 50px"
              }
            }, [_createElementVNode("b", null, "点击上方”选择文件\"或将文件拖拽到此区域"), _createElementVNode("div", {
              class: "el-upload__tip",
              style: {
                "line-height": "1.3"
              }
            }, [_createTextVNode(" 支持pdf/mp4/mov格式"), _createElementVNode("br"), _createTextVNode(" 视频小于5G，pdf小于10M ")])], -1))]),
            _: 1
          }, 8, ["action"])), [[_directive_loading, identityLoading.value]])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("video", {
            style: {
              "width": "100%",
              "height": "100%"
            },
            src: form.identityCosUrl,
            controls: ""
          }, null, 8, _hoisted_9)])])])]),
          _: 1
        }), _cache[30] || (_cache[30] = _createElementVNode("h3", null, "Demo脚本", -1)), _cache[31] || (_cache[31] = _createElementVNode("div", {
          class: "flex-row-box",
          style: {
            "justify-content": "flex-start",
            "margin-bottom": "10px"
          }
        }, [_createTextVNode(" 文本驱动内容 "), _createElementVNode("span", {
          class: "note-text",
          style: {
            "margin-left": "10px"
          }
        }, "根据您输入的文本合成语音并生成数智人驱动demo视频")], -1)), _createVNode(_component_el_input, {
          type: "textarea",
          modelValue: form.textDriver,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.textDriver = $event),
          rows: 14,
          min: 4,
          max: 1000,
          "show-word-limit": true,
          style: {
            "width": "26vw"
          }
        }, null, 8, ["modelValue"]), customrizeType.value.includes(1) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_cache[23] || (_cache[23] = _createElementVNode("h3", null, "形象素材", -1)), _createVNode(_component_el_form_item, {
          label: "视频背景"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: form.isHaveBackground,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.isHaveBackground = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: false
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("需我方抠像")])),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: true
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("无需我方抠像")])),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "训练素材",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
            class: "flex-row-box",
            style: {
              "justify-content": "flex-start",
              "align-items": "flex-end"
            }
          }, [_cache[21] || (_cache[21] = _createElementVNode("p", {
            style: {
              "width": "30%"
            }
          }, "每个素材独立训练，请分别按服装特征严格命名加以区分", -1)), _createElementVNode("p", {
            style: {
              "margin-left": "40px",
              "width": "30%"
            }
          }, [_cache[19] || (_cache[19] = _createTextVNode(" 为保障口型训练素材充分，请参考 ")), _createElementVNode("a", {
            class: "active-text-plain",
            onClick: downloadAuthPaper
          }, "《小样本口播参考文稿》"), _cache[20] || (_cache[20] = _createTextVNode("录制 "))])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_withDirectives((_openBlock(), _createBlock(_component_el_upload, {
            drag: "",
            "element-loading-text": "正在上传",
            "auto-upload": true,
            action: `${_unref(baseApi)}/app/virtualManApi/custom/upload/video`,
            "on-success": handleVideoSuccess,
            "on-change": handleVideoChange,
            "before-upload": handleVideoBeforeUpload,
            limit: 1,
            multiple: false,
            ref: "videoUpload"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-icon--upload",
              size: "20px"
            }, {
              default: _withCtx(() => [_createVNode(_component_plus)]),
              _: 1
            }), _cache[22] || (_cache[22] = _createElementVNode("div", {
              class: "el-upload__text",
              style: {
                "padding": "20px 50px"
              }
            }, [_createElementVNode("b", null, "点击上方”选择文件\"或将文件拖拽到此区域"), _createElementVNode("div", {
              class: "el-upload__tip",
              style: {
                "line-height": "1.3",
                "text-align": "left"
              }
            }, [_createTextVNode(" 1、视频大小不超过5GB，时长不短于1分钟、不长于10分钟"), _createElementVNode("br"), _createTextVNode(" 2、视频格式为mp4、mov"), _createElementVNode("br"), _createTextVNode(" 3、视频分辨率1080P、4K（3840*2160），宽高比符合16:9（9:16）"), _createElementVNode("br"), _createTextVNode(" 4、视频帧率不低于25fps、不高于60fps"), _createElementVNode("br"), _createTextVNode(" 5、定制引擎会为您的视频素材自动适配通用口型数据，因此生成的数智人可能与模特发音口型习惯、口型外观存在差异，若您希望获得与模特更高吻合度的口型特征，请选择定制小样本（专属口型） ")])], -1))]),
            _: 1
          }, 8, ["action"])), [[_directive_loading, videoLoading.value]])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("video", {
            style: {
              "width": "100%",
              "height": "100%"
            },
            src: form.materialCosUrl,
            controls: ""
          }, null, 8, _hoisted_14)])])])]),
          _: 1
        })], 64)) : _createCommentVNode("", true), customrizeType.value.includes(2) || form.makeType == 'VOICE' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_cache[26] || (_cache[26] = _createElementVNode("h3", null, "音色素材", -1)), _createVNode(_component_el_form_item, {
          label: "训练素材",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_withDirectives((_openBlock(), _createBlock(_component_el_upload, {
            "element-loading-text": "正在上传",
            class: "upload-demo",
            drag: "",
            action: `${_unref(baseApi)}/app/virtualManApi/custom/upload/audio`,
            "on-success": handleAudioSuccess,
            "on-change": handleAudioChange,
            "before-upload": handleAudioBeforeUpload,
            limit: 1,
            multiple: false
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-icon--upload",
              size: "20px"
            }, {
              default: _withCtx(() => [_createVNode(_component_plus)]),
              _: 1
            }), _cache[24] || (_cache[24] = _createElementVNode("div", {
              class: "el-upload__text",
              style: {
                "padding": "20px 30px"
              }
            }, [_createElementVNode("b", null, "点击上方”选择文件\"或将文件拖拽到此区域"), _createElementVNode("div", {
              class: "el-upload__tip",
              style: {
                "line-height": "1.3",
                "text-align": "left"
              }
            }, [_createTextVNode(" 1、zip包不超过1G，包含不超过10条⾳频文件"), _createElementVNode("br"), _createTextVNode(" 2、压缩时选中所有音频文件直接压缩，不可新建文件夹后压缩"), _createElementVNode("br"), _createTextVNode(" 3、音频采样率建议24k、36k，音频文件格式wav、mp3、wma、m4a、aac"), _createElementVNode("br"), _createTextVNode(" 4、音频命名无空格或者特殊字符 ")])], -1))]),
            _: 1
          }, 8, ["action"])), [[_directive_loading, audioLoading.value]])]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_svgIcon, {
            iconClass: "wjj",
            width: "60px",
            height: "60px"
          }), _cache[25] || (_cache[25] = _createElementVNode("p", null, "示例音频文件.zip", -1)), _createElementVNode("a", {
            class: "active-text-plain",
            onClick: downloadAuthFile
          }, "点击下载")])])])]),
          _: 1
        })], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_checkbox, {
        modelValue: agree.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => agree.value = $event),
        size: "large"
      }, {
        default: _withCtx(() => [_cache[32] || (_cache[32] = _createTextVNode("我已阅读并同意")), _createElementVNode("a", _hoisted_20, "《定制" + _toDisplayString(form.makeType != 'VOICE' ? '形象' : '音色') + "协议》", 1)]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("a", null, [_createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        disabled: !agree.value,
        onClick: onSubmit
      }, {
        default: _withCtx(() => _cache[33] || (_cache[33] = [_createTextVNode("确认提交")])),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: _cache[10] || (_cache[10] = $event => _unref(router).go(-1)),
        plain: ""
      }, {
        default: _withCtx(() => _cache[34] || (_cache[34] = [_createTextVNode("取消")])),
        _: 1
      })])])])]);
    };
  }
});